import React from 'react';
import { ConfigFieldControl } from '@sierralabs/core-ui';
import SiteQueryPicker from '../common/pickers/SiteQueryPicker';
import { useConfigComponent } from '../hooks/component/useConfigComponent';
const SiteConfigComponentQuery = props => {
    const { multiple, component: initialComponent } = props;
    const { component, update } = useConfigComponent(initialComponent);
    return (React.createElement(ConfigFieldControl, null,
        React.createElement(SiteQueryPicker, { label: 'Query', value: component.queryIds || [], onChange: queries => {
                queries = multiple ? queries : queries.slice(-1);
                update('queryIds', queries.map(query => query.id));
            } })));
};
export default SiteConfigComponentQuery;
//# sourceMappingURL=SiteConfigComponentQuery.js.map